// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8eeca6c","453":"a32e37b3","732":"6914c313","977":"ec061c28"}[chunkId] + ".chunk.js";
};